module.exports = __webpack_public_path__ + "static/media/19ю102.edb4dc06.jpg";